<template>
    <section>
        <!-- 検索窓 -->
        <el-col :span="24" class="toolbar" style="padding-bottom: 0px;" v-loading="toolbarLoading">
            <el-form :inline="true" :model="filters">
                <el-form-item>
                    <el-input v-model="filters.name" placeholder="ユーザ名（部分一致）" style="width: 200px;"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" v-on:click="getUsers">検索</el-button>
                    <el-button type="primary" v-on:click="exportCsv" v-if="adminRole">CSV出力</el-button>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="handleAdd">新規追加</el-button>
                </el-form-item>
                <el-pagination layout="prev, pager, next" @current-change="handleCurrentChange" :page-size="30"
                               :total="total" style="float:right;">
                </el-pagination>
            </el-form>
        </el-col>
        <!-- /検索窓 -->

        <!-- リスト -->
        <el-table :data="users" highlight-current-row v-loading="listLoading" @selection-change="selsChange"
                  style="width: 100%;">
            <el-table-column type="selection" width="55">
            </el-table-column>
            <el-table-column prop="name" label="ユーザ名" width="300" sortable>
            </el-table-column>
            <el-table-column prop="role" label="権限" width="300" sortable>
                <template scope="scope">
                    {{ getRoleName(scope.row.role) }}
                </template>
            </el-table-column>
            <el-table-column prop="updatedAt" label="更新日時" width="210" sortable>
                <template scope="scope">
                    {{ scope.row.updatedAt | formatDate }}
                </template>
            </el-table-column>
            <el-table-column label="操作" width="150">
                <template scope="scope">
                    <el-button size="small" @click="handleEdit(scope.$index, scope.row)">編集</el-button>
                    <el-button type="danger" size="small" @click="handleDel(scope.$index, scope.row)">削除</el-button>
                </template>
            </el-table-column>
        </el-table>
        <!-- /リスト -->

        <!-- 一括削除 -->
        <el-col :span="24" class="toolbar">
            <el-button type="danger" @click="batchRemove" :disabled="this.sels.length===0">一括削除</el-button>
        </el-col>
        <!-- /一括削除 -->

        <!-- 編集画面 -->
        <el-dialog title="編集" v-model="editFormVisible" :close-on-click-modal="false" @close="closeEditForm">
            <el-form :model="editForm" label-width="80px" :rules="editFormRules" ref="editForm">
                <el-form-item label="ID" prop="id">
                    <el-input v-model="editForm.id" disabled></el-input>
                </el-form-item>
                <el-form-item label="ユーザ名" prop="name">
                    <el-input v-model="editForm.name" disabled></el-input>
                </el-form-item>
                <el-form-item label="パスワード" prop="password">
                    <el-input v-model="editForm.password" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="権限" prop="role">
                    <el-select v-model="editForm.role" placeholder="選択して下さい" value-key="id">
                        <el-option value=""></el-option>
                        <el-option v-for="(item, index) in roles"
                                   :key:="index"
                                   :value="index"
                                   :label="item">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="作成日時">
                    <el-date-picker type="datetime"
                                    placeholder="作成日時"
                                    format="yyyy/MM/dd HH:mm"
                                    v-model="editForm.createdAt"
                                    disabled>
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="更新日時">
                    <el-date-picker type="datetime"
                                    placeholder="更新日時"
                                    format="yyyy/MM/dd HH:mm"
                                    v-model="editForm.updatedAt"
                                    disabled>
                    </el-date-picker>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click.native="closeEditForm">取消</el-button>
                <el-button type="primary" @click.native="editSubmit" :loading="editLoading">登録</el-button>
            </div>
        </el-dialog>
        <!-- /編集画面 -->

        <!-- 新規追加 -->
        <el-dialog title="新規追加" v-model="addFormVisible" :close-on-click-modal="false" @close="closeAddForm">
            <el-form :model="addForm" label-width="80px" :rules="addFormRules" ref="addForm">
                <el-form-item label="ユーザ名" prop="name">
                    <el-input v-model="addForm.name" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="パスワード" prop="password">
                    <el-input v-model="addForm.password" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="権限" prop="role">
                    <el-select v-model="addForm.role" placeholder="選択して下さい" value-key="id">
                        <el-option value=""></el-option>
                        <el-option v-for="(item, index) in roles"
                                   :key:="index"
                                   :value="index"
                                   :label="item">
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click.native="closeAddForm">取消</el-button>
                <el-button type="primary" @click.native="addSubmit" :loading="addLoading">登録</el-button>
            </div>
        </el-dialog>
        <!-- /新規追加 -->

    </section>
</template>

<script>
    import ElOption from "../../../node_modules/element-ui/packages/select/src/option.vue";
    import { formatDate } from "../../components/filters/format";
    import config from "../../config/app";
    import * as User from '../../api/cognitoUser';
    import moment from "moment";

    export default {
        components: { ElOption },
        filters: { formatDate },
        data() {
            return {
                filters: {
                    name: ''
                },
                users: [],
                roles: User.roles,
                total: 0,
                page: 1,
                listLoading: false,
                sels: [],
                adminRole: User.checkAdminRoleBySession(),
                toolbarLoading: false,

                // 編集系
                editFormVisible: false,
                editLoading: false,
                editFormRules: {
                    password: [
                        { required: true, validator: this.validatePassword, trigger: 'blur' },
                    ],
                    role: [
                        { required: true, message: '権限を選択してください', trigger: 'change' }
                    ],
                },
                editForm: {
                    id: '',
                    name: '',
                    password: '',
                    role: '',
                },

                // 新規系
                addFormVisible: false,
                addLoading: false,
                addFormRules: {
                    name: [
                        { required: true, message: 'ユーザ名を入力してください', trigger: 'blur' }
                    ],
                    password: [
                        { required: true, validator: this.validatePassword, trigger: 'blur' },
                    ],
                    role: [
                        { required: true, message: '権限を選択してください', trigger: 'change' }
                    ],
                },
                addForm: {
                    name: '',
                    password: '',
                    role: '',
                }

            }
        },
        methods: {
            validatePassword(rule, value, callback) {
                if (value.length < 8) {
                    callback(new Error("8文字以上のパスワードを入力してください。"));
                } else if (!value.match(/[0-9]+/)) {
                    callback(new Error("英大文字、英小文字、数字を組み合わせたパスワードを入力してください。"));
                } else if (!value.match(/[a-z]+/)) {
                    callback(new Error("英大文字、英小文字、数字を組み合わせたパスワードを入力してください。"));
                } else if (!value.match(/[A-Z]+/)) {
                    callback(new Error("英大文字、英小文字、数字を組み合わせたパスワードを入力してください。"));
                } else {
                    callback();
                }
            },
            handleCurrentChange(val) {
                this.page = val;
                this.getUsers();
            },
            getUsers() {
                let params = {
                    search: this.filters.name,
                    count: config.pageCount,
                    offset: (this.page - 1) * config.pageCount,
                };
                this.listLoading = true;
                User.getUsers(params)
                    .then(res => {
                        this.users = res.list;
                        this.total = res.total;
                        this.listLoading = false;
                    });
            },
            getRoleName(role) {
                return User.roles[role];
            },
            handleDel: function (index, row) {
                this.$confirm('削除してもよろしいですか？', '確認', { type: 'warning' })
                        .then(() => {
                            this.listLoading = true;
                            return User.deleteUser(row);
                        })
                        .then(res => {
                            this.listLoading = false;
                            this.$message({
                                message: '削除しました',
                                type: 'success'
                            });
                            this.getUsers();
                        })
                        .catch(err => {
                            console.log(err)
                        });
            },
            handleEdit: function (index, row) {
                this.editFormVisible = true;
                this.editForm = Object.assign({}, row);
                this.editForm.password = '';
            },
            handleAdd: function () {
                this.addFormVisible = true;
                this.addForm = {
                    name: '',
                    password: '',
                    role: '',
                };
            },
            closeAddForm() {
                this.$refs.addForm.resetFields();
                this.addFormVisible = false;
            },
            closeEditForm() {
                this.$refs.editForm.resetFields();
                this.editFormVisible = false;
            },
            editSubmit: function () {
                this.$refs.editForm.validate((valid) => {
                    if (valid) {
                        this.$confirm('登録してもよろしいですか？', '確認', {})
                            .then(() => {
                                this.editLoading = true;
                                const params = Object.assign({}, this.editForm);
                                return User.editUser(params);
                            })
                            .then(res => {
                                this.editLoading = false;
                                this.$message({
                                    message: '登録しました',
                                    type: 'success'
                                });
                                this.closeEditForm();
                                this.getUsers();
                            });
                    }
                });
            },
            addSubmit: function () {
                this.$refs.addForm.validate((valid) => {
                    if (valid) {
                        this.$confirm('登録してもよろしいですか？', '確認', {})
                            .then(() => {
                                this.addLoading = true;
                                const params = Object.assign({}, this.addForm);
                                return User.createUser(params);
                            })
                            .then(res => {
                                this.addLoading = false;
                                this.$message({
                                    message: '登録しました',
                                    type: 'success'
                                });
                                this.closeAddForm();
                                this.getUsers();
                            })
                            .catch(err => {
                                this.addLoading = false;
                                if (err !== 'cancel') {
                                    let message = 'エラーが発生しました。';
                                    if (err.code === 'UsernameExistsException') {
                                        message = '登録済みのユーザ名です。ユーザ名を変更して下さい';
                                    }
                                    this.$message({
                                        message: message,
                                        type: 'warning'
                                    });
                                }
                            });
                    }
                });
            },
            selsChange: function (sels) {
                this.sels = sels;
            },
            batchRemove: function () {
                this.$confirm('選択した項目を削除してもよろしいですか？', '確認', { type: 'warning' })
                        .then(() => {
                            this.listLoading = true;
                            return User.batchDelete(this.sels);
                        })
                        .then((res) => {
                            this.listLoading = false;
                            this.$message({
                                message: '削除しました',
                                type: 'success'
                            });
                            this.getUsers();
                        });
            },
            exportCsv: async function() {
                this.listLoading = true;
                this.toolbarLoading = true;
                // ヘッダ行
                const columns = [
                    'ユーザ名',
                    '権限',
                    '更新日時',
                ];
                const header = columns.join(',') + '\n';

                // データ取得（全件）
                const params = {
                    search: '',
                };
                const user = await User
                        .getUsers(params)
                        .then(res => {
                            return res.list;
                        });

                // 更新日時で降順ソート
                user.sort((a, b) => {
                    if (a.updatedAt > b.updatedAt) return -1;
                    if (a.updatedAt < b.updatedAt) return 1;
                    return 0;
                });

                let arrUser = [];
                for (var i = 0; i < user.length; i++) {
                    const data = [
                        user[i].name,
                        this.getRoleName(user[i].role),
                        formatDate(user[i].updatedAt),
                    ];
                    arrUser.push(data);
                }
                const body = arrUser.join('\n');

                // CSVダウンロード
                const iconv = require("iconv-lite");
                const data = iconv.encode(header + body, 'windows-31j');
                const blob = new Blob([ data ], { "type" : "text/csv" });
                const url = window.URL.createObjectURL(blob);

                let link = document.createElement('a');
                link.download = 'swipe_user_' + moment().format("YYYYMMDD") + '.csv';
                link.href = url;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                this.listLoading = false;
                this.toolbarLoading = false;
            }
        },
        mounted() {
            this.getUsers();
        }
    }

</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// User.vue?7a36f842